import { render, staticRenderFns } from "./AppCountries.vue?vue&type=template&id=4c80f430&"
import script from "./AppCountries.vue?vue&type=script&lang=js&"
export * from "./AppCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports